// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:40
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class LinkCardsArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.LinkCardsArgs';
  $t: string = 'SagaBase.Defines.LinkCardsArgs';

  public static GetMembers(): string[] {
    return ['Source', 'Target', 'LinkGroupDescription', 'LinkDescription', 'IsDirectLinkRequest'];
  }

  public GetMembers(): string[] {
    return LinkCardsArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Source: Guid[];
  public Target: Guid = GuidTools.Empty;
  public LinkGroupDescription: any;
  public LinkDescription: string;
  public IsDirectLinkRequest: boolean;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
